export default __webpack_public_path__ + "static/media/loading.df5bdac5.gif";